import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "secret-data-tab-basic" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "m-20 text-center no-rows" }


import DetailText from '@shell/components/DetailText.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';

export interface Row {
    key?: string;
    value?: string;
}

export interface Props {
    rows: Row[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Basic',
  props: {
    rows: {}
  },
  setup(__props: any) {


const store = useStore();
const i18n = useI18n(store);

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (row, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "entry"
      }, [
        _createVNode(DetailText, {
          value: row.value,
          label: row.key,
          conceal: true,
          "conceal-stand-alone": true
        }, null, 8, ["value", "label"])
      ]))
    }), 128)),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (!__props.rows.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).t('sortableTable.noRows')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})